import {addAlert} from '_app/shared/features/TransientNotifications/TransientNotificationsActions';
import {actionCreatorMake, Enums} from '_app/utils';
import {
	emailService,
	tagGroupService,
	categoriesService,
	mediaService,
	mediaVersionService,
	sectionsService
} from '_app/services';
import MediaItemsActions from '_app/shared/actions/MediaItemsActions';
import {fetchFavoriteMedia} from '_app/mediahub/scenes/LandingPage/FavoriteMedia/favoriteMediaActions';

export const MEDIA_HUB_ACTION_NAMES = { // TODO: move all action names
	CLEAR_FILTERS_VALUES: 'CLEAR_FILTERS_VALUES',
	CHANGE_FILTER_VALUE: 'CHANGE_FILTER_VALUE'
};

export default (function () {
	const categoryRequest = actionCreatorMake('CATEGORY_REQUEST', 'sectionId');
	const categorySuccess = actionCreatorMake('CATEGORY_SUCCESS', 'sectionId', 'data', 'receivedAt');
	const categoryFailure = actionCreatorMake('CATEGORY_FAILURE', 'sectionId');
	const categoryBreakCache = actionCreatorMake('CATEGORY_BREAK_CACHE');

	const filtersRequest = actionCreatorMake('FILTERS_REQUEST', 'section');
	const filtersSuccess = actionCreatorMake('FILTERS_SUCCESS', 'section', 'data', 'receivedAt');
	const filtersFailure = actionCreatorMake('FILTERS_FAILURE', 'section');

	const itemSuccess = actionCreatorMake('MEDIA_ITEM_SUCCESS', 'id', 'version', 'data', 'receivedAt');

	function categoriesFetch(sectionId, proxiedAsId = null) {
		return function(dispatch) {
			dispatch(categoryRequest(sectionId));

			return categoriesService
				.getCategories(sectionId, proxiedAsId)
				.done(function(data) {
					// Trim the name to work around weird Router behavior
					for (let i = 0; i < data.length; i++) {
						data[i].name = data[i].name.trim();
					}
					dispatch(categorySuccess(sectionId, data, Date.now()));
				})
				.fail(function(xhr, message) {
					dispatch(addAlert('Error retrieving categories: ' + message));
					dispatch(categoryFailure(sectionId));
				});
		};
	}

	function filtersFetch(section) {
		return function (dispatch) {
			var sectionId = sectionsService.getMediaSections().find(s => s.name === section).value;

			dispatch(filtersRequest(section));

			return tagGroupService
				.fetchFilters(sectionId)
				.done(function(data) {
					dispatch(filtersSuccess(section, data, Date.now()));
				})
				.fail(function(xhr, message) {
					dispatch(addAlert('Error retrieving filters: ' + message));
					dispatch(filtersFailure(section));
				});
		};
	}

	function loadMediaItemWithVersion(id, version) {
		return function(dispatch) {
			const promises = [
				dispatch(MediaItemsActions.mediaItemFetch(id)),
				dispatch(MediaItemsActions.versionFetch(id, version))
			];

			return Promise.all(promises).catch(err => {
				dispatch(addAlert('Error retrieving filters: ' + err.message));
			});
		};
	}

	function emailTemplateFetch(id, version) {
		var templateRequest = actionCreatorMake('EMAIL_START_REQUEST');
		var templateSuccess = actionCreatorMake('EMAIL_START_SUCCESS');
		var templateFailure = actionCreatorMake('EMAIL_START_FAILURE');
		var templateStart = actionCreatorMake('EMAIL_FROM_TEMPLATE', 'data');

		return function (dispatch) {
			var media = {};

			dispatch(templateRequest());

			return mediaService.get(id)
				.then(function(data) {
					media = Object.assign({}, data);
					return mediaVersionService.get(id, version);
				})
				.then(function(data) {
					if (!data) {
						throw 'Version is unavailable';
					}
					dispatch(templateStart(Object.assign(media, data)));
					dispatch(templateSuccess());
				})
				.fail(function() {
					dispatch(templateStart({
						ID: 0, Version: 0, Name: 'Share this media'
					}));
					dispatch(templateFailure());
				});
		};
	}

	// Exported functions
	// =====================

	// Request categories if not request already. Categories are cached, if
	// the request returned succesfully the receivedAt value will be set.
	function categoriesLoad(sectionId, proxiedAsId = null) {
		return function (dispatch, getState) {
			var categories = getState().categoriesBySection[sectionId];

			if (!categories || (!categories.isFetching && !categories.receivedAt)) {
				return dispatch(categoriesFetch(sectionId, proxiedAsId));
			}
		};
	}

	// Check and request filters
	function filtersLoad(section) {
		return function(dispatch, getState) {
			var filters = getState().filtersBySection[section];

			if (!filters || (!filters.isFetching && !filters.receivedAt)) {
				return dispatch(filtersFetch(section));
			}
		};
	}

	function itemFavorite(id, isFavorite, refreshFavorites, selectedFilter, proxiedAsId) {
		var favChange = actionCreatorMake('ITEM_FAVORITE_CHANGE', 'id', 'isFavorite');
		var failure = actionCreatorMake('ITEM_FAVORITE_CHANGE_FAILURE', 'message');

		return function(dispatch) {
			mediaService.favorite(id, isFavorite)
				.done(function() {
					dispatch(favChange(id, isFavorite));
					if (refreshFavorites) {
						dispatch(fetchFavoriteMedia(selectedFilter, proxiedAsId));
					}
				})
				.fail(function(jqXHR, message) {
					dispatch(addAlert('Error favoriting item: ' + message));
					dispatch(failure(id, isFavorite));
				});
		};
	}

	function emailDraftLoad(messageId) {
		var emailStart = actionCreatorMake('EMAIL_FROM_DRAFT', 'email');
		var emailSuccess = actionCreatorMake('EMAIL_START_SUCCESS');
		var emailFailure = actionCreatorMake('EMAIL_START_FAILURE');
		var emailRequest = actionCreatorMake('EMAIL_START_REQUEST');

		return function (dispatch) {
			var storedEmail = null; // TODO, get from store

			if (storedEmail) {
				// dispatch the start action with item
			} else {
				dispatch(emailRequest());
				return emailService
					.get(messageId)
					.then(function(data) {
						dispatch(emailStart(data));
						dispatch(emailSuccess());
					}, function(xhr, message) {
						dispatch(addAlert('Error loading email: ' + message));
						dispatch(emailFailure());
					});
			}
		};
	}

	function emailTemplateLoad(id, version) {
		var emailStart = actionCreatorMake('EMAIL_FROM_TEMPLATE', 'data');

		return function (dispatch, getState) {
			var key = id + '_' + version;

			if (key === '0_0') {
				return dispatch(emailTemplateCreate(id, version));
			} else {
				const item = getState().items.byIds[key];

				if (item) {
					dispatch(emailStart(item));
					return $.Deferred().resolve();
				} else {
					return dispatch(emailTemplateFetch(id, version));
				}
			}
		};
	}

	function emailTemplateCreate(id, version) {
		var emailStart = actionCreatorMake('EMAIL_FROM_TEMPLATE', 'data');

		return function (dispatch) {
			var item = {
				Subject: null,
				Body: null,
				Graphic: null,
				HeaderOption: Enums.getType('headerOptionTypes').LEFTALIGN,
				TemplateID: null,
				TemplateVersion: null,
				ID: id,
				Version: version,
				Name: 'Share this Media'
			};

			dispatch(emailStart(item));
			return $.Deferred().resolve();
		};
	}

	const {CLEAR_FILTERS_VALUES, CHANGE_FILTER_VALUE} = MEDIA_HUB_ACTION_NAMES;

	function clearFiltersValues() {
		return {
			type: CLEAR_FILTERS_VALUES
		};
	}

	function changeFilterValue(data) {
		return {
			type: CHANGE_FILTER_VALUE,
			data
		};
	}

	return {
		categoriesLoad: categoriesLoad,
		categoryBreakCache: categoryBreakCache,
		filtersLoad: filtersLoad,
		itemFavorite: itemFavorite,
		loadMediaItemWithVersion: loadMediaItemWithVersion,
		emailTemplateLoad: emailTemplateLoad,
		emailTemplateCreate: emailTemplateCreate,
		emailDraftLoad: emailDraftLoad,
		clearFiltersValues: clearFiltersValues,
		changeFilterValue: changeFilterValue,
		itemSuccess // refactor
	};
})();